import 'core-js/features/promise'; // polyfill for Vuex
import DetectKeyboardUser from 'detect-keyboard-user';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import smoothscroll from 'smoothscroll-polyfill';

import '../scss/main.scss';

import './components/async';
import './components/global';

import BootstrapBreakpoints from './helpers/BootstrapBreakpoints';
import JSvh from './helpers/JSvh';
import store from './store';
import UserAgentParser from './helpers/UserAgentParser';

/* eslint-disable-next-line */
const vh = new JSvh();

/* eslint-disable-next-line */
const myDKU = new DetectKeyboardUser();

smoothscroll.polyfill();

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';
Vue.config.silent = true;

Vue.use(Vuelidate);

export const bus = new Vue();

new Vue({
  provide() {
    return {
      oneTrustCheck: this.oneTrustCheck
    };
  },
  data() {
    return {
      oneTrustCheck: {
        otIsReady: false,
        isTargetingCookiesActive: false,
        OnetrustActiveGroupsCheck: null,
      }
    };
  },
  store,
  created() {
    // This a workaround for the Sitecore Experience Editor
    // Vue strips the key attribute from <code> elements, but it is needed
    // Feel free to find a more elegant solution!
    if (!document.body.classList.contains('is-experience-editor')) return;
    const codeTags = document.querySelectorAll('code');
    for (let i = 0; i < codeTags.length; i += 1) {
      const tag = codeTags[i];
      const attr = tag.getAttribute('key');
      if (attr) {
        tag.setAttribute('sc-key', attr);
      }
    }
  },
  mounted() {
    this.checkforOneTrust();

    //check for changes in the OneTrust active groups
    window.addEventListener("OneTrustGroupsUpdated", () => this.checkForTrackingCookies());
    
    //LiveChat
    if (window.LiveChatWidget) {
      window.LiveChatWidget.on('ready', () => {
        document.querySelectorAll('iframe').forEach((el) => {
          // The frameborder and scrolling attributes on the iframe element are obsolete.
          el.removeAttribute('frameborder');
          el.removeAttribute('scrolling');
        });
      });
    }

    // This a workaround for the Sitecore Experience Editor
    // Vue strips the key attribute from <code> elements, but it is needed
    // Feel free to find a more elegant solution!
    if (!document.body.classList.contains('is-experience-editor')) return;

    const codeTags = document.querySelectorAll('code');
    for (let i = 0; i < codeTags.length; i += 1) {
      const tag = codeTags[i];
      const attr = tag.getAttribute('sc-key');
      if (attr) {
        tag.setAttribute('key', attr);
      }
    }
  },
  beforeDestroy() { 
    window.removeEventListener("OneTrustGroupsUpdated", this.checkForTrackingCookies());
  },
  methods: {
 
    checkforOneTrust() {
      console.log("checkforOneTrust()");
      let checkCount = 0;
      const maxChecks = 4;
      this.checkInterval = setInterval(() => {
        checkCount++;
        if (typeof OnetrustActiveGroups !== 'undefined') {
          console.log("OneTrust active groups are now defined.");
          this.oneTrustCheck.isReady = true;
          this.checkForTrackingCookies();
          clearInterval(this.checkInterval);
        } else if (checkCount >= maxChecks) {
          console.log("OneTrust active groups are still undefined after 4 checks.");
          this.oneTrustCheck.isReady = false;
          clearInterval(this.checkInterval);
        } else {
          console.log(`Waiting for OneTrust active groups to be defined... (Attempt ${checkCount} of ${maxChecks})`);
        }
      }, 1000); // Checks every second
    },
    
    checkForTrackingCookies() {
      if (OnetrustActiveGroups.includes('C0004')) { // Targeting Cookies
        this.oneTrustCheck.isTargetingCookiesActive = true;
        console.log("Targeting Cookies active");
      } else {
        this.oneTrustCheck.isTargetingCookiesActive = false;
        console.log("Targeting Cookies not active");
      }
      this.oneTrustCheck.OnetrustActiveGroupsCheck = OnetrustActiveGroups;

    }
  }
}).$mount('#app');

new UserAgentParser().addClasses();
new BootstrapBreakpoints().detect();

if (process.env.NODE_ENV === 'development') {
  if (module.hot) {
    module.hot.accept();
  }
}
